import { NavLink, useLocation } from "react-router-dom";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../../elements/Button";
import { isNavigationPathActive } from "./navigationPaths";
import { getSitemapIcon } from "../../pages/sitemap/sitemapIcons";

function NavigationLink({
  className,
  disabled,
  icon,
  identifiers,
  text,
  to,
  openInNewTab,
  url,
}) {
  const { pathname } = useLocation();
  const linkIcon = getSitemapIcon(icon);
  const label = linkIcon ? (
    <>
      <FontAwesomeIcon icon={linkIcon} fixedWidth className="me-2" />
      {text}
    </>
  ) : (
    text
  );
  // Some pages live at a different path than the nav item's own `to`, so `identifiers`
  // lists every path counting as "on this page", as getCurrentPageInfo does.
  const isCurrentPage = (identifiers || [to]).some((path) =>
    isNavigationPathActive(pathname, path)
  );
  if (disabled) {
    return (
      <li>
        <Button
          className={classNames(
            className,
            "nav-link",
            "disabled",
            "text-muted"
          )}
          disabled
          variant="link"
          text={label}
        />
      </li>
    );
  }

  return (
    <li>
      <NavLink
        to={openInNewTab && url ? url : to}
        className={classNames(
          className,
          isCurrentPage ? "active" : "",
          "nav-link"
        )}
        state={{
          canGoBack: true,
        }}
        target={openInNewTab ? "_blank" : ""}
        rel={openInNewTab ? "noreferrer" : ""}
      >
        {label}
      </NavLink>
    </li>
  );
}

export default NavigationLink;
